<template>
  <div class="handbook-step-wrapper" v-if="application">
    <div class="uk-grid" v-if="applicant">
      <div class="uk-width-1-1 student-info">
        <p class=""><strong>Student Name:</strong> {{ student.first_name }} {{ student.last_name }}</p>
        <p class=""><strong>Date of Birth:</strong> {{ student.birth_date | bday }}</p>
      </div>
      <div class="uk-width-1-1 uk-margin-top">
        <p class="header-p"><strong>I agree to:</strong></p>
        <ul>
          <li>be in a safe and supportive learning environment, free from discrimination, harassment, and
            bigotry;</li>
          <li>know what appropriate behavior and what behaviors may result in disciplinary actions;</li>
          <li>be counseled by members of the professional staff in matters related to my behavior as it
            affects my work ethic and welfare within the job setting; and</li>
          <li>due process of law in instances of disciplinary action for alleged violations of work policies
            for which I may be removed from the work program.</li>
        </ul>
      </div>
      <div class="uk-width-1-1 uk-margin-top">
        <p class="header-p"><strong>I know that I have a right to:</strong></p>
        <ul>
          <li>arrive on time; missing more than 1 hour of programming per day could result in “no
            credit/incentive” given for that day;</li>
          <li>program dismissal if I miss Week 1 of the program;</li>
          <li>attend each of my workshops at the start time, ready to begin work;</li>
          <li>be prepared with appropriate materials and assignments for all classes;</li>
          <li>show respect to all members of the learning community;</li>
          <li>resolve conflicts peacefully and avoid fighting inside or outside of the program sites;</li>
          <li>behave respectfully, without arguing, and cooperate when a staff member gives direction or makes
            a request. I understand that I will be given an opportunity to voice my concerns at an
            appropriate time if I do not agree with the request;</li>
          <li>take responsibility for my personal belongings and respect other people’s property;</li>
          <li>remain in my assigned area and/or team unless granted permission from program staff to be
            elsewhere;</li>
          <li>dress appropriately and do not wear any offensive, controversial or suggestive clothing (with
            words or images) including skinny tank-tops, low-cut or midriffs, short-shorts, or mini-skirts;
          </li>
          <li>refrain from wearing clothes which have any signs of gang affiliation (e.g., scarves, bandanas)
            and refrain from using gang signs, calls, chants, movements, and handshakes;</li>
          <li>refrain from bringing weapons, illegal drugs, controlled substances, and alcohol to the program;
          </li>
          <li>refrain from using personal possessions that are disruptive (e.g., cell phone, beeper, pager);
          </li>
          <li>share information with staff that might affect the health, safety, or welfare of the work
            program;</li>
          <li>keep my parents/guardians informed about work-related matters and make sure I give them any
            information sent home;</li>
          <li>behave responsibly;</li>
          <li>follow all rules in the Behavioral Contract.; and</li>
          <li>have fun!!</li>
        </ul>
      </div>
      <div class="uk-width-1-1 uk-margin-top">
        <p class="header-p"><strong>Disciplinary Course of Action:</strong></p>
        <ul>
          <li>Big Brother/ Big Sister Coaching</li>
          <li>Associate Dean Coaching</li>
          <li>Parent/Guardian and Associate Dean Meeting</li>
          <li>Dismissal from Program</li>
        </ul>
      </div>
      <div class="uk-width-1-1 uk-margin-top">
        <p class="">I have received a copy of the WRT University/Ready2Earn behavioral contract and understand
          this
          contract. I agree to follow the rules of behavior.</p>
      </div>
      <div class="uk-width-small-1-1 uk-width-medium-1-1 uk-width-large-1-2 uk-margin-large-top">
        <h3>Student Signature:</h3>
        <validated-section :field="'signature_' + student.id" :errors="errors">
          <signature-box @updated="onSignatureUpdated" :user-key="student.id"
            :is-signed="signatureData[student.id] && signatureData[student.id].signed_at !== null"
            :completed="signatureData[student.id] && signatureData[student.id].completed"
            :name="student.first_name + ' ' + student.last_name"
            :color="programSettings['primary-program-color']"></signature-box>
        </validated-section>
      </div>
      <br />
      <template v-if="!userIsStudent">
        <hr />
        <div class="uk-width-1-1 uk-margin-large-top">
          <h2 class="uk-text-center"><strong>Parent Section</strong></h2>
          <p class="">I have received a copy of the <strong><i>WRT University/Ready2Earn behavioral contract</i></strong> and understand
            the behavior that is required of my child.</p>
          <p class="header-p"><strong>Disciplinary Course of Action:</strong></p>
          <ul>
            <li>encouraging my child to be a respectful and peaceful member of the school community;</li>
            <li>discussing the contents of the behavioral contract with my child;</li>
            <li>participating in any discussions and decisions concerning my child's work experience;</li>
            <li>providing the program with current telephone numbers and emergency contact information;</li>
            <li>alerting the program if there are any significant changes in my child's health, or well-being
              that affect his/her ability to perform.</li>
          </ul>
        </div>
        <div class="uk-width-small-1-1 uk-width-medium-1-1 uk-width-large-1-2 uk-margin-large-top">
          <h3>Parent Signature:</h3>
          <validated-section :field="'signature_' + applicant.id" :errors="errors">
            <signature-box @updated="onSignatureUpdated" :user-key="applicant.id"
                           :is-signed="signatureData[applicant.id] && signatureData[applicant.id].signed_at !== null"
                           :completed="signatureData[applicant.id] && signatureData[applicant.id].completed"
                           :name="applicant.first_name + ' ' + applicant.last_name"
                           :color="programSettings['primary-program-color']"></signature-box>
          </validated-section>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
// import moment from 'moment'
import SignatureBox from "./../../../../../../../components/AppWizard/SignatureBox";
import ValidatedSection from "./../../../../../../../components/Common/ValidatedSection";

export default {
  name: "BehaviorStep",
  props: {
    print: {
      type: Boolean,
      default: false,
    }
  },
  components: { ValidatedSection, SignatureBox },
  data() {
    return {
      errors: {},
      loading: false,
      signatureData: {},
    }
  },

  mounted() {
    if (this.application) {
      this.initData();
    }
  },

  watch: {
  },

  computed: {
    user() {
      return this.$store.getters['App/user']
    },

    ...mapState('Application', {
      application: 'application',
      applicant: 'applicant',
      signatures: 'signatures',
      userIsStudent: 'userIsStudent',
    }),
    ...mapGetters('Application', ['student', 'programSettings']),
  },

  methods: {
    initData() {
      const applicantSignatureFiltered = this.applicant && this.applicant.signatures && this.applicant.signatures.find(item => item.key === `app-jobs-behavior`)
      if (applicantSignatureFiltered && this.applicant) {
        this.$set(this.signatureData, this.applicant.id, { signed_at: applicantSignatureFiltered.created_at, completed: true });
      }
      const signatureFiltered = this.signatures && this.signatures.find(item => item.key === `app-jobs-behavior`)
      if (signatureFiltered && this.student) {
        this.$set(this.signatureData, this.student.id, { signed_at: signatureFiltered.created_at, completed: true });
      }
    },

    onSignatureUpdated($event) {
      if (!this.signatureData[$event.key]) {
        this.$set(this.signatureData, $event.key, {});
      }
      this.$set(this.signatureData, $event.key, { signed_at: $event.isSigned ? moment().format('YYYY-MM-DD HH:mm') : null });
    },

    scrollTop: function () {
      if (window.pageYOffset > 0) {
        this.intervalId = setInterval(() => {
          if (window.pageYOffset === 0) {
            clearInterval(this.intervalId)
          }
          window.scroll(0, window.pageYOffset - 50)
        }, 5)
      }
    },

    async validateStep() {
      this.errors = {}
      let stepValid = false;

      // applicant signature validation
      if(!this.userIsStudent) {
        if (!this.signatureData[this.applicant.id]) {
          this.errors['signature_' + this.applicant.id] = {
            errors: [this.applicant.first_name + ' ' + this.applicant.last_name + ' must sign this form as their name appears above.'],
          };
        } else if (this.signatureData[this.applicant.id] && this.signatureData[this.applicant.id].signed_at == null) {
          this.errors['signature_' + this.applicant.id] = {
            errors: [this.applicant.first_name + ' ' + this.applicant.last_name + ' must sign this form as their name appears above.'],
          };
        }
      }


      // student signature validation
      if (!this.signatureData[this.student.id]) {
        this.errors['signature_' + this.student.id] = {
          errors: [this.student.first_name + ' ' + this.student.last_name + ' must sign this form as their name appears above.'],
        };
      } else if (this.signatureData[this.student.id] && this.signatureData[this.student.id].signed_at == null) {
        this.errors['signature_' + this.student.id] = {
          errors: [this.student.first_name + ' ' + this.student.last_name + ' must sign this form as their name appears above.'],
        };
      }

      if (_.size(this.errors) == 0) {
        stepValid = await this.save()
      }

      if (!stepValid) {
        setTimeout(() => {
          this.scrollTop()
        }, 10);
      }

      return stepValid
    },

    async save() {
      let stepValid = false
      this.$emit('loading', true)
      let data = {
        signatures: this.signatureData,
      }
      await axios.put(`/api/hope/jobs/applications/${this.application.id}/step-behavior`, data)
        .then((res) => {
          this.$emit('done', res)
          this.$emit('loading', false)
          stepValid = true
        })
        .catch((err) => {
          // if (err.response.data.errors) {
          //   this.serverValidationErrors = err.response.data.errors;

          // }
          this.$emit('loading', false)
          stepValid = false
        })

      return stepValid
    }
  }
}
</script>

<style lang="scss">
.handbook-step-wrapper {
  .uk-card-primary {
    color: white;
    background-color: #0f7ae5;
    padding: 40px;
    font-size: 1.2em;
    border-radius: 6px;
  }

  .student-info {
    font-size: 1.4em !important;
    margin-bottom: 10px;
  }

  .header-p {
    font-size: 1.4em !important;
  }
}
</style>
